import { Theme } from "@mui/material/styles";

export const PINNED_TEXT_FIELD_INPUT_HEIGHT = "32.6px";

export const styles = (theme: Theme) => {
  return {
    root: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      flexWrap: "nowrap",
      "& .MuiOutlinedInput-root": {
        "& .MuiOutlinedInput-input": {
          py: "4px",
          px: theme.spacing(1),
          width: "6em",
          boxSizing: "border-box",
          lineHeight: 1.25,
        },
      },
    },
    label: {
      px: theme.spacing(0.75),
    },
  };
};
